import React, { useCallback, useContext, useEffect, useState } from 'react'
import { AppContext } from '../../Context'
import { MemoryRouter, Redirect, Route, Switch, useHistory, useParams } from 'react-router'
import EmployeeContact from './EmployeeContact'
import ChildInfo from './ChildInfo'
import RecordSent from './RecordSent'
import RecordSignature from './RecordSignature'
import RecordAttachment from './RecordAttachment'
import { getRecord, updateRecordQuery } from '../../services/record-services'

export const RecordContext = React.createContext({})

function RecordPage({ ...props }) {
  const { tokenId } = useContext(AppContext)
  const [record, setRecord] = useState(null)
  const [original, setOriginal] = useState(null)

  const history = useHistory()
  const { id } = useParams()

  const steps = [
    {
      url:'/child-info'
    },{
      url:'/employee-contact'
    },{
      url:'/attachment'
    },{
      url:'/signature'
    }
  ]

  const fetchRecord = useCallback( async () => {
    const result = await getRecord(id, recordData)
    if (result.data.getRecord && result.data.getRecord.length > 0) {
      const r = result.data.getRecord[0]
      reloadRecord(r)
    } else {
      history.push('/error/404')
    }
  }, [id, history])

  useEffect(() => {
    if (id && tokenId) {
      fetchRecord()
    }
  }, [id, tokenId, fetchRecord])

  const setRecordValue = (key, value) => {
    setRecord({
      ...record,
      [key]: value
    })
  }

  const updateRecord = (updateQuery) => {
    if (record && !record.disabled) {
      return updateRecordQuery(record._id, record.status, updateQuery, recordData)
      .then(resp => {
        if(resp.data && resp.data.updateRecord) {
          const r = resp.data.updateRecord
          reloadRecord(r)
        }
        return resp
      })
    }
    return {}
  }

  const reloadRecord = (lastSavedRecord) => {

    // If the file has not the CREATED status (SENT, ...) then the employee cannot update his file anymore :
    if (lastSavedRecord.status !== 'CREATED') {
      lastSavedRecord.disabled = true
    }

    setRecord(lastSavedRecord)
    setOriginal(lastSavedRecord)

  }

  return record ?
    <MemoryRouter>
      <RecordContext.Provider value={ { parentHistory: history, record, setRecord, setRecordValue, original, setOriginal, updateRecord, steps } }>
        <Switch>
          <Route path={ '/' } exact={ true } render={ () => <Redirect to="/child-info"/> }/>
          <Route path={ '/child-info' } component={ ChildInfo }/>
          <Route path={ '/employee-contact' } component={ EmployeeContact }/>
          <Route path={ '/attachment' } component={ RecordAttachment }/>
          <Route path={ '/signature' } component={ RecordSignature }/>
          <Route path={ '/record-sent'} component={RecordSent}/>
        </Switch>
      </RecordContext.Provider>
    </MemoryRouter>
   : null
}

export default RecordPage

export const recordData = `
  _id
  basageId
  reference
  status
  partnerAnnualNetIncome
  singleParent
  babysittingMode
  specialContract
  hoursType
  startDate
  child {
    id
    ageCategory
    expired
    dateOfBirth
    firstName
    lastName
  }
  attachments {
    category
    key
    name
    size
    mimetype
    audited
    auditedBy
    auditOk
  }
  events {
    date
    type
    owner
    message
  }
  auditOkDate
  auditKoDate
`

